import { render, staticRenderFns } from "./DetailSurvey.vue?vue&type=template&id=690cf073&scoped=true"
import script from "./DetailSurvey.vue?vue&type=script&lang=js"
export * from "./DetailSurvey.vue?vue&type=script&lang=js"
import style0 from "./DetailSurvey.vue?vue&type=style&index=0&id=690cf073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690cf073",
  null
  
)

export default component.exports